










helpers = require('../../helpers.coffee')

view_model =
  components:
    flowForm: require './form.vue'

  data: ->
    flow: new Flow

  methods:
    flowPath: ->
      "/fluxos-de-cadencia/#{@flow_id}"

    loadFlow: ->
      Loader.on()
      new FlowsResource().get @loadSuccess, @unknownError, id: @flow_id

    loadSuccess: (resources) ->
      Loader.off()
      @flow = resources.flow
      @redirectIfNotOwner(@flow)

  created: ->
    @flow_id = @$route.params.id
    EventsBus.$on 'ActionPicker:Created', @loadFlow

  beforeDestroy: ->
    EventsBus.$off 'ActionPicker:Created', @loadFlow

exports.default = helpers.vue_include(view_model, helpers.form)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/flows/edit.vue